import * as types from './../constants/actionTypes';
import initialState from './initialState';

/**
 * @param state
 * @param action
 * @return {*}
 */

export default function (state = initialState.users, action) {
   switch (action.type) {
      case types.LOGIN_USER : {
         return action.payload;
      }

      case types.REMOVE_USER : {
         return {};
      }

      default:
         return state;
   }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/sessionReducers.js
 **/